var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { IMaskInput } from 'react-imask';
export function createIMaskInput(config) {
    return React.forwardRef((props, ref) => {
        const { onChange } = props, otherProps = __rest(props, ["onChange"]);
        return (React.createElement(IMaskInput, Object.assign({}, config, otherProps, { inputRef: ref, onAccept: (value, mask, event) => {
                // without this if, onChange is called for the first render, not what we want
                if (event) {
                    onChange({ target: { name: props.name, value: value } });
                }
            } })));
    });
}
